import { Box, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ContainerContent from "src/commonStyles/container/containerContent/containerContent";
import SesstionTitle from "src/commonStyles/text/sessionTitile/sessionTitle";
import TextBase from "src/commonStyles/text/textBase/textBase";
import { payFrequency, statusPolicy } from "src/const";
import useCheckMobile from "src/hook/useCheckMobile";
import { IDataPolicy } from "src/interface/inforPay";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from "react-router-dom";
import ProductName from "./productName";

const useStyle = makeStyles((theme) => {
  return {
    rowItem: {
      paddingBottom: "44px",
      [theme.breakpoints.down("md")]: {
        paddingBottom: "22px",
      },
    },
    styleValue: {
      fontWeight: 600,
      textAlign: "right",
    },
  };
});

interface IProps {
  hasPolicy?: boolean;
  dataPolicy?: IDataPolicy;
  isShowBtnBack?: boolean;
  frSystm?: string;
}

const PolicyInfo = (props: IProps) => {
  const { hasPolicy, dataPolicy, frSystm, isShowBtnBack } = props;

  return (
    <div>
      {hasPolicy ? (
        <PolicyInfoHasPolicy data={dataPolicy} isShowBtnBack={isShowBtnBack} />
      ) : (
        <PolicyInfoNoPolicy data={dataPolicy} isShowBtnBack={isShowBtnBack} />
      )}
    </div>
  );
};
export default PolicyInfo;

const PolicyInfoHasPolicy = (props: { data: IDataPolicy, frSystm?: string, isShowBtnBack?: boolean }) => {
  const { data, isShowBtnBack, frSystm } = props;
  const classes = useStyle();
  const navigate = useNavigate();

  return (
    <ContainerContent>
      <div className="flex items-center justify-start">
        {/* {isShowBtnBack &&
          <div onClick={() => navigate('/?frSystm=LAMB2')} className="pb-5">
            <ArrowBackIosIcon/>
          </div>
        } */}
        <div onClick={() => navigate(frSystm ? `/?frSystm=${frSystm}` : '/')} className="pb-5">
          <ArrowBackIosIcon />
        </div>
        <SesstionTitle>Thông tin hợp đồng</SesstionTitle>
      </div>
      <Grid container columnSpacing={10}>
        <Grid item md={6} xs={12}>
          <Grid container>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase>Số hợp đồng bảo hiểm</TextBase>
            </Grid>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase className={classes.styleValue}>
                {data?.idNumber}
              </TextBase>
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={6} xs={0} />

        {/* <Grid item md={2} xs={0} /> */}
        {/* <Grid item md={5} xs={0} /> */}
        {/*  */}
        <Grid item md={6} xs={12}>
          <Grid container>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase>Bên mua bảo hiểm</TextBase>
            </Grid>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase className={classes.styleValue}>{data?.phName}</TextBase>
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item md={} xs={0} /> */}
        <Grid item md={6} xs={12}>
          <Grid container>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase>Người được bảo hiểm</TextBase>
            </Grid>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase className={classes.styleValue}>{data?.laName}</TextBase>
            </Grid>
          </Grid>
        </Grid>
        {/*  */}

        <Grid item md={6} xs={12}>
          <Box className={classes.rowItem} display="flex" alignItems="center" gap={2}>
            <Box className="max-w-[50%] md:max-w-full">
              <TextBase>Sản phẩm bảo hiểm</TextBase>
            </Box>

            <Box flex={1} >
              <ProductName value={data?.prdName} className={classes.styleValue} />
            </Box>
          </Box>
        </Grid>
        {/* <Grid item md={2} xs={0} /> */}
        <Grid item md={6} xs={12}>
          <Grid container>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase>Trạng thái hợp đồng</TextBase>
            </Grid>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase className={classes.styleValue}>
                {data?.status?.toUpperCase() === "ACTIVE"
                  ? statusPolicy.Active
                  : statusPolicy.Lapsed}
              </TextBase>
            </Grid>
          </Grid>
        </Grid>
        {/*  */}

        <Grid item md={6} xs={12}>
          <Grid container>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase>Định kỳ đóng phí</TextBase>
            </Grid>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase className={classes.styleValue}>
                {
                  payFrequency?.find((item) => item?.id === data?.payFrequency)
                    ?.name
                }
              </TextBase>
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item md={2} xs={0} /> */}
        <Grid item md={6} xs={12}>
          <Grid container>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase>Phí định kỳ</TextBase>
            </Grid>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase className={classes.styleValue}>
                {(() => {
                  const feeAmount = Number(data?.feeAmt);
                  const validAmount = isNaN(feeAmount) ? 0 : feeAmount;
                  return new Intl.NumberFormat("en-US", { style: "decimal" }).format(validAmount);
                })()}{" "}
                VND
              </TextBase>
            </Grid>
          </Grid>
        </Grid>
        {/*  */}
      </Grid>
    </ContainerContent>
  );
};

const PolicyInfoNoPolicy = (props: { data: IDataPolicy,  frSystm?: string , isShowBtnBack?: boolean }) => {
  const { data, isShowBtnBack , frSystm} = props;
  const classes = useStyle();
  const navigate = useNavigate();

  return (
    <ContainerContent>
      <div className="flex items-center justify-start">
        {/* {isShowBtnBack &&
          <div onClick={() => navigate('/?frSystm=LAMB2')} className="pb-5">
            <ArrowBackIosIcon/>
          </div>
        } */}
        <div onClick={() => navigate(frSystm ? `/?frSystm=${frSystm}` : '/')} className="pb-5">
          <ArrowBackIosIcon />
        </div>
        <SesstionTitle>Thông tin hợp đồng</SesstionTitle>
      </div>
      <Grid container columnSpacing={10}>
        {/*  */}
        <Grid item md={6} xs={12}>
          <Box
            style={{ display: "flex", justifyContent: "space-between" }}
            className={classes.rowItem}
          >
            <Box>
              <TextBase>Mã hồ sơ yêu cầu bảo hiểm</TextBase>
            </Box>
            <Box>
              <TextBase className={classes.styleValue}>
                {data?.idNumber}
              </TextBase>
            </Box>
          </Box>
          {/* <Grid container>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase>Mã hồ sơ yêu cầu bảo hiểm</TextBase>
            </Grid>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase className={classes.styleValue}>
                {data?.idNumber}
              </TextBase>
            </Grid>
          </Grid> */}
        </Grid>
        {/* <Grid item md={6} xs={0} /> */}
        {/* <Grid item md={2} xs={0} /> */}
        <Grid item md={6} xs={12}>
          <Grid container>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase>Sản phẩm bảo hiểm</TextBase>
            </Grid>
            <Grid item xs={6} className={classes.rowItem}>
              <ProductName
                value={data?.prdName}
                className={classes.styleValue}
              />
            </Grid>
          </Grid>
        </Grid>
        {/*  */}

        <Grid item md={6} xs={12}>
          <Grid container>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase>Bên mua bảo hiểm</TextBase>
            </Grid>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase className={classes.styleValue}>{data?.phName}</TextBase>
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item md={2} xs={0} /> */}
        <Grid item md={6} xs={12}>
          <Grid container>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase>Người được bảo hiểm</TextBase>
            </Grid>
            <Grid item xs={6} className={classes.rowItem}>
              <TextBase className={classes.styleValue}>{data?.laName}</TextBase>
            </Grid>
          </Grid>
        </Grid>
        {/*  */}
      </Grid>
    </ContainerContent>
  );
};
